import { render, staticRenderFns } from "./StakeEdit.vue?vue&type=template&id=2c0de607&scoped=true&"
import script from "./StakeEdit.vue?vue&type=script&lang=js&"
export * from "./StakeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0de607",
  null
  
)

export default component.exports